module.exports = __webpack_public_path__ + "static/img/titvi.e2a74cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entry/img/titvi.png
// module id = g7EQ
// module chunks = 1